export default __webpack_public_path__ + "static/media/linkedin.d76f022a.png";